module.exports = __webpack_public_path__ + "static/img/gptModel53.9c8bf9f3.png";